module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/regenerator/index.js
// module id = 626
// module chunks = 0